import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAllHardwareTypesBySystem } from '../../../api/hardware';

const useHardwareTypeSystem = (
  systemId?: string,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) =>
  useQuery({
    queryKey: ['hardwareTypeBySystem', systemId],
    queryFn: getAllHardwareTypesBySystem,
    ...options,
  });

export default useHardwareTypeSystem;
